/* eslint-disable max-len */
import { CallHospitalIcon, ClinicLocationIcon, CloseIcon, UserMailIcon }
  from "../../../components/Icons";
import { CentralLoadingIndicator, MapMini } from "../../../components";
import React, { useEffect, useState } from "react";

import { Box } from "@mui/material";
import HomeHospitalDetails from "../../../components/HomeHospital/HomeHospitalDetails";
import { useHospitalList } from "../../../services/edit-hospital-location/edit-hospital-location.service";
import { useModal } from "../../../context/ModalContext";
import { useUserStore } from "../../../hooks/redux-hooks/user-store/user.store";
import { getContactString } from "../../containers/ChangeHospitalContainer/ChangeHospitalContainer";
import { useHospitalDetailsListStore } from "../../../hooks/redux-hooks/hospital-details-list-store/hospital-details-list-store";

const ContactHospitalModal = () => {
  const { closeModal } = useModal();
  const { metroLocations, loading, getMetroLocations, currentLocation } = useHospitalList();
  const { currentLocation: currentHospitalLocation, hospitalDetailsList, isHospitalListUpdated } = useHospitalDetailsListStore();
  const [markers, setMarkers] = useState<any[]>([]);
  const [mapData, setMapData] = useState<any>({});
  const [selectedLocation, setSelectedLocation] = useState<{ location: any } | null>(null);
  const [isBubble, setIsBubble] = useState<boolean>(false);
  const { user } = useUserStore();


  useEffect(() => {
    // call the getMetroLocations api call if the store is not already updated
    !isHospitalListUpdated && getMetroLocations();
    setIsBubble(false);
  }, []);


  const handleMarkerClick = (mark: any) => {
    setIsBubble(true);
    setSelectedLocation(mark);
    setMapData(mark.position);
  };

  useEffect(() => {
    // will execute if the getMetroLocations response is not already present in store
    if (metroLocations) {
      setMarkers(metroLocations?.filter((item) => item.idLocation === currentLocation));
      setMapData({ lat: metroLocations?.[0]?.position?.lat, lng: metroLocations?.[0]?.position?.lng });
    }
  }, [metroLocations]);

  useEffect(() => {
    // will execute if the getMetroLocations response is already present in store
    if (isHospitalListUpdated && hospitalDetailsList) {
      setMarkers(hospitalDetailsList?.filter((item: any) => item.idLocation === currentHospitalLocation));
      setMapData({ lat: hospitalDetailsList?.[0]?.position?.lat, lng: hospitalDetailsList?.[0]?.position?.lng });
    }
  }, []);

  if (loading) return <CentralLoadingIndicator/>;

  return (
    <div className="relative h-[95%] w-full">
      <div className="flex justify-end mb-4">
        <CloseIcon
          onClick={closeModal}
          className="text-light-black cursor-pointer mt-1"
        />
      </div>

      <div className="h-[90%] overflow-y-auto p-6 pe-4 flex flex-col gap-4 items-center w-full">

        <div className="flex flex-col gap-2 items-start w-full">

          <h6 className="text-gray-1 text-sm font-semibold">Your Home Hospital</h6>

          <div className="flex gap-2 items-start">

            <ClinicLocationIcon width={24} height={24} color="#262626"/>
            <div className="flex flex-col gap-1">
              <h6 className="font-semibold  text-base">{user?.location?.locationName}</h6>
              <h6 className="text-xs">{user?.location?.address}</h6>


            </div>

          </div>
        </div>

        <div className="flex flex-col p-6 border border-taupe-50 bg-white rounded-lg w-full gap-3">
          <h6 className="text-gray-1 text-sm font-semibold">Hospital Contact</h6>
          <a href={`mailto:${user?.location?.email}`}>
            <div className="flex gap-4 items-center">
              <UserMailIcon width={24} height={24}/>
              <h6 className="text-sm font-semibold">{user?.location?.email}</h6>
            </div>
          </a>
          <a href={getContactString(user?.location?.phoneNumber ? user?.location?.phoneNumber : "")}>
            <div className="flex gap-4 items-center">
              <CallHospitalIcon width={24} height={24}/>
              <h6 className="text-sm font-semibold">{user?.location?.phoneNumber}</h6>
            </div>
          </a>
        </div>

        <Box className="border border-1 w-full">
          <MapMini
            lat={mapData?.lat}
            lng={mapData?.lng}
            markers={markers}
            mapData={mapData}
            onClick={handleMarkerClick}
            isBubble={isBubble}
            location={selectedLocation}
            setIsBubble={setIsBubble}
            width="100%"
            height="10rem"
          />
        </Box>
        {user?.location?.locationName &&
          <div className="w-full">
            <HomeHospitalDetails locationName={user?.location?.locationName} />
          </div>}
      </div>

    </div>
  );
};

export default ContactHospitalModal;
